const contactUsStyle = Object.freeze({
  needMoreHelp: Object.freeze({
    buttonVariant: 'neutralOpaque',
    buttonColor: 'white',
    selectVariant: 'neutralContactUs',
  }),
  subjectButton: Object.freeze({
    paddingBottom: '8rem',
    imageStyle: Object.freeze({
      width: '85%',
      marginTop: '0',
    }),
    extend: ({ theme, }) => ({
      size: [
        theme.type(1, { untilBp: 's', }),
        theme.type(2, { fromBp: 's', }),
      ],
    }),
  }),
  question: ({ theme, }) => ({
    extend: {
      extend: [
        theme.type(0, { untilBp: 'm', }),
        theme.type(-1, { fromBp: 'm', }),
      ],
    },
  }),
  icon: Object.freeze({
    transform: 'rotate(0deg)',
  }),
  thankYouForm: Object.freeze({
    fontSize: ({ theme, }) => ({
      extend: [
        theme.type(1, { untilBp: 'm', }),
        theme.type(3, { fromBp: 'm', }),
      ],
    }),
    extendBlock: ({ theme, }) => ({
      extend: [
        theme.type(3, { untilBp: 'm', }),
        theme.type(5, { fromBp: 'm', }),
        theme.mq({ from: 'm', }, { paddingRight: '7rem', paddingLeft: '7rem', marginTop: '25%', }),
        theme.mq({ until: 'm', }, { marginTop: '6rem', marginBottom: '6rem', }),
      ],
    }),
  }),
});

export default contactUsStyle;
